module.exports = __webpack_public_path__ + "static/media/targaryen_power.7142072c.png";